export default __webpack_public_path__ + "static/media/sidebar-icon-4.36c72bd2.svg";